// src/mockData/snapshotFreemiumMock.tsx

import { Database, Lightbulb, BarChart3, Lock, TrendingUp } from "lucide-react";
import type { SnapshotCardConfig } from "../components/snapshot/SnapshotFreemiumCard";

export const mockPersonalizationData = {
  strategy: 40,
  capabilities: 35,
  readiness: 45,
  docsCount: 0,
};

// 8 card configs for Tools view
// Icons passed as PRE-STYLED JSX with explicit white color
export const mockFreemiumSnapshotCards: SnapshotCardConfig[] = [
  {
    id: "welcome",
    icon: <Database className="w-6 h-6" style={{ color: '#FFFFFF', stroke: '#FFFFFF' }} />,
    title: "Welcome to DVA",
    description:
      "Get started with your data strategy journey. Complete your profile to unlock personalized insights.",
    contentType: "list",
    listItems: [
      "Complete your personalization profile",
      "Explore industry benchmarks",
      "Review data strategy overview",
      "Upgrade to Pro for full access",
    ],
    primaryCtaLabel: "Start Personalization →",
  },
  {
    id: "benchmarks",
    icon: <BarChart3 className="w-6 h-6" style={{ color: '#FFFFFF', stroke: '#FFFFFF' }} />,
    title: "Industry Benchmarks",
    description: "See how leading health systems score on analytics readiness.",
    contentType: "benchmark",
    benchmarkData: [
      { label: "Data governance", value: 78, color: "#C4CDD7" },
      { label: "Analytics maturity", value: 65, color: "#A3B1C2" },
      { label: "Interoperability", value: 52, color: "#C4CDD7" },
    ],
  },
  {
    id: "initiatives",
    icon: <TrendingUp className="w-6 h-6" style={{ color: '#FFFFFF', stroke: '#FFFFFF' }} />,
    title: "Top Data Initiatives (2025)",
    description: "Most impactful analytics priorities across health systems.",
    contentType: "list",
    listItems: [
      "AI-powered care gap analysis",
      "Patient 360° view platforms",
      "Real-time quality dashboards",
      "Value-based care analytics",
    ],
  },
  {
    id: "roi_themes",
    icon: <BarChart3 className="w-6 h-6" style={{ color: '#FFFFFF', stroke: '#FFFFFF' }} />,
    title: "Emerging ROI Themes",
    description:
      "Trending analytics opportunities delivering measurable financial impact.",
    contentType: "roi_themes",
  },
  {
    id: "personalized_insights",
    icon: <Lightbulb className="w-6 h-6" style={{ color: '#FFFFFF', stroke: '#FFFFFF' }} />,
    title: "Your Personalized Insights",
    description:
      "Once you complete personalization, DVA highlights your highest-value opportunities.",
    contentType: "sample_insights",
    listItems: [
      "Example: Reduce ED LOS with analytics-driven staffing.",
      "Example: Improve VBC quality scores using risk stratification.",
    ],
    primaryCtaLabel: "Start Personalization →",
  },
  {
    id: "coaching",
    icon: <Lightbulb className="w-6 h-6" style={{ color: '#FFFFFF', stroke: '#FFFFFF' }} />,
    title: "Coaching Services",
    description:
      "Get expert guidance on analytics strategy, ROI modeling, and data readiness.",
    contentType: "coaching",
    listItems: [
      "Analytics & ROI strategy sessions",
      "Data readiness & governance support",
      "Clinical & operational transformation coaching",
    ],
    primaryCtaLabel: "Visit Coaching Center →",
  },
  {
    id: "premium_insights",
    icon: <Lock className="w-6 h-6" style={{ color: '#FFFFFF', stroke: '#FFFFFF' }} />,
    title: "Premium Insights",
    description:
      "Unlock your organization's custom ROI model and analytics portfolio insights.",
    contentType: "benchmark",
    benchmarkData: [
      { label: "Strategic alignment", value: 85, color: "#2A3E54" },        // Softened navy
      { label: "Implementation readiness", value: 72, color: "#A3B1C2" },
      { label: "Financial impact", value: 90, color: "#C4CDD7" },
    ],
    locked: true,
    primaryCtaLabel: "Unlock with DVA Pro →",
  },
  {
    id: "custom_roadmap",
    icon: <Lock className="w-6 h-6" style={{ color: '#FFFFFF', stroke: '#FFFFFF' }} />,
    title: "Custom Roadmap",
    description:
      "Generate a prioritized analytics roadmap for your organization.",
    contentType: "roi_themes",
    locked: true,
    primaryCtaLabel: "Unlock for ROI Modeling →",
  },
];